import React from 'react';
import PropTypes from 'prop-types';
import {
    useSelectionIsBetable,
    useSelectionDecimalPrice,
    useSelectionFractionPrice,
    useSelectionAmericanPrice,
    useSelectionSpecialOddsValue,
    useSelectionType,
} from '~SpectateStore/hooks/selectionsHooks';
import BetButton from '~shared/components/react/BetButton';
import { getSelectionLabel } from '~shared/utils/selections-utils';

const BetButtonSelection = ({ id, showSelectionLabels = false }) => {
    const decimal_price = useSelectionDecimalPrice(id);
    const fraction_price = useSelectionFractionPrice(id);
    const american_price = useSelectionAmericanPrice(id);
    const betable = useSelectionIsBetable(id);
    const specialoddsvalue = useSelectionSpecialOddsValue(id);
    const type = useSelectionType(id);
    const label = getSelectionLabel({selection: {
        specialoddsvalue,
        type,
    }});

    return <BetButton
        options= {{
            id,
            betable,
            suspended: !betable,
            sp_only: false,
            decimal_price,
            fraction_price,
            american_price,
            label,
        }}
        showSelectionLabels= {showSelectionLabels}
        doTranslateLabel={false}
    />;
};

BetButtonSelection.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    showSelectionLabels: PropTypes.bool,
};

export default BetButtonSelection;
